import { getRequiredFieldsForStep } from './buttonState';

const validate = async (stepId, steps, componentMap, checkoutPageState, trigger) => {
  const requiredFields = getRequiredFieldsForStep(stepId, steps, componentMap, checkoutPageState);
  const validationPromises = requiredFields.map((field) => trigger(field));
  const results = await Promise.all(validationPromises);
  return results.every((isValid) => isValid);
};

export default validate;
